import axios from "axios";
import { config } from "../config";

const getFaqs = async (): Promise<any> => {
  try {
    // if (config.environment === "development") {
    const response = await axios.get(`/inputs/faq.json`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
    // }

    // const faqUrl = `${config.faqListUrl}/faq.json`;
    // const response = await axios.get(faqUrl);

    // return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export { getFaqs };
